<template>
  <div class="message-container" ref="message-container">
    <MessageArea title="留言板" :subTitle="`(${data.total})`" :isListLoading="isLoading" :list="data.rows"
      @submit="handleSubmit" />
  </div>
</template>

<script>
import MessageArea from "@/components/MessageArea";
import fetchData from "@/mixins/fetchData";
import * as msgApi from "@/api/message";
import mainScroll from "@/mixins/mainScroll";
export default {
  components: {
    MessageArea,
  },
  data() {
    return {
      page: 1,
      limit: 10,
    }
  },
  mixins: [fetchData({ total: 0, rows: [] }), mainScroll("message-container")],
  created() {
    this.$bus.$on("mainScroll", this.handleScroll)
  },
  computed: {
    hasMore() {
      return this.data.rows.length < this.data.total;
    }
  },
  destroyed() {
    this.$bus.$off("mainScroll", this.handleScroll)
  },
  methods: {
    async fetchData() {
      return msgApi.getMessage(this.page, this.limit);
    },
    async handleSubmit(data, callback) {
      const resp = await msgApi.postMessage(data);
      callback("感谢您的留言");
      this.data.rows.unshift(resp);
    },
    async handleScroll(dom) {
      if (this.isLoading || !dom) {
        return;
      }
      const range = 100;
      const dec = Math.abs((dom.scrollTop + dom.clientHeight) - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    },
    async fetchMore() {
      if (!this.hasMore) {
        return;
      }
      this.isLoading = true;
      this.page++;
      const resp = await this.fetchData();
      this.data.total = resp.total;
      this.data.rows = this.data.rows.concat(resp.rows);
      this.isLoading = false;
    },
  }

}
</script>

<style scoped>
.message-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 25px 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

.message-area-container {
  width: 700px;
  margin: 0 auto;
}
</style>